import React, {ReactNode} from 'react'
import styled from '@emotion/styled'

import {Card} from '@vio/atlas/Card'
import {Box} from '@vio/atlas/helpers/Box'
import {Tag} from '@vio/atlas/Tag'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

const TransparentCard = styled(Card)`
  background: transparent;
`
const Heading = styled.div`
  display: flex;
  flex-wrap: wrap-reverse;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s250};
`

const HeadingTitle = styled.div`
  flex: 0 0 auto;
  max-width: 100%;
`

const HeadingTag = styled.div`
  flex: 0 0 auto;
  white-space: nowrap;
`

interface Props {
  dataId?: string
  title: ReactNode
  tagLabel: ReactNode
  children: ReactNode
}

export const DealFreezeBannerCard: React.FC<Props> = ({
  dataId,
  title,
  tagLabel,
  children
}) => (
  <TransparentCard
    dataId={dataId}
    borderRadius="lg"
    borderColorPath="border.neutral.secondary"
  >
    <Box display="flex" flexDirection="column" gap="s250" padding="s400">
      <Heading>
        <HeadingTitle>
          <Text variant="titleS">{title}</Text>
        </HeadingTitle>
        <HeadingTag>
          <Tag variant="brand" size="sm">
            {tagLabel}
          </Tag>
        </HeadingTag>
      </Heading>
      <Text variant="bodyXS" colorPath="content.neutral.secondary">
        {children}
      </Text>
    </Box>
  </TransparentCard>
)
